module.exports = __webpack_public_path__ + "img/shipsen.c6b05d92.png";